import React, { useCallback } from 'react';
import { makeStyles } from 'tss-react/mui';
import Icon from '../../../icons/components/Icon';
import { COLORS } from '../../constants';
import { isMobileBrowser } from "../../../environment/utils";
const useStyles = makeStyles()(theme => {
    return {
        label: {
            fontFamily: 'Lato Medium',
            fontWeight: 'normal',
            fontSize: '12px',
            lineHeight: '15px',
            alignItems: 'center',
            background: theme.palette.ui04,
            borderRadius: '4px',
            color: theme.palette.text01,
            display: 'flex',
            margin: '0 4px',
            padding: '3.5px 6px 3.5px 4px',
            boxSizing: 'border-box',
            '&.is-mobile': {
                fontFamily: 'Inter Medium',
                fontWeight: 'normal',
                borderRadius: '6px',
                margin: '0 2px',
                padding: '4.5px 6px 5.5px 4px',
            },
        },
        withIcon: {
            marginLeft: '8px',
            '&.is-mobile': {
                marginLeft: '4px',
            },
        },
        clickable: {
            cursor: 'pointer'
        },
        [COLORS.white]: {
            background: theme.palette.ui09,
            color: theme.palette.text04,
            '& svg': {
                fill: theme.palette.icon04
            }
        },
        [COLORS.green]: {
            background: theme.palette.success02
        },
        [COLORS.red]: {
            background: theme.palette.actionDanger
        }
    };
});
const Label = ({ accessibilityText, className, color, icon, iconColor, iconSize, id, onClick, text }) => {
    const { classes, cx } = useStyles();
    const isMobile = isMobileBrowser();
    const onKeyPress = useCallback(event => {
        if (!onClick) {
            return;
        }
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onClick();
        }
    }, [onClick]);
    return (React.createElement("div", { className: cx(classes.label, onClick && classes.clickable, color && classes[color], className, isMobile && 'is-mobile'), id: id, onClick: onClick, onKeyPress: onKeyPress, role: onClick ? 'button' : undefined, tabIndex: onClick ? 0 : undefined },
        icon && React.createElement(Icon, { color: iconColor, size: iconSize ?? '16', src: icon }),
        accessibilityText && React.createElement("span", { className: 'sr-only' }, accessibilityText),
        text && React.createElement("span", { className: cx(icon && classes.withIcon, isMobile && 'is-mobile') }, text)));
};
export default Label;
